import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
      user_id: 'LayaEAP'
  },
    getters:{
      user_id: state => state.user_id
    },
  mutations: {
    login(state){
      state.isLoggedIn = true
    },
      logout(state){
          state.isLoggedIn = false
      }
  },
  actions: {
  },
    plugins: [
        createPersistedState({
            paths: [
                "isLoggedIn"
            ]
        })
    ],
})
